<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-0
        v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic100--text {{ $t('save_changes') }}
          v-col.ml-3.shrink
            v-layout
              v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                .button-AA-small.basic100--text {{ $t('cancel') }}
              v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                .button-AA-small.primary500--text {{ $t('save') }}
        v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('page_content') }}

      v-card-text.pa-0
        landing-page-editor(v-if="form['landing_field'] !== undefined" :parentForm.sync="form")
          template(#title)
            div.d-flex.align-center
              div.h5.primary--text *{{ $t('main_content') }}*
              v-spacer
              v-chip.px-2(v-if="form.members && form.members.length > 0" outlined color="primary" small @click="clickViewPage")
                eva-icon.mr-1(name="eye-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24" style="margin-bottom: -6px")
                div.c2.primary--text.mr-1 {{ $t('preview') }}

            div.s1.primary--text.mt-5 {{ $t('tell_visitor_about') }}
            div.p2.basic700--text.mt-1 {{ $t('make_sure_click_publish') }}
  
</template>

<script>
import { mapActions } from 'vuex'
import LandingPageEditor from '@/components/landingform/LandingPageEditor.vue'

export default {
  name: 'EditLandingPageContent',
  props: ['open', 'parentForm', 'company'],
  components: { LandingPageEditor },
  data: () => ({
    isLoading: false,
    form: {},
    original: {}
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.original) === JSON.stringify(this.form)) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.form = JSON.parse(JSON.stringify(this.parentForm))
    this.original = JSON.parse(JSON.stringify(this.parentForm))
  },
  methods: {
    ...mapActions(['showMessage']),
    clickRevert () {
      this.form = JSON.parse(JSON.stringify(this.original))
    },
    clickSave () {
      this.isLoading = true
      let data = {
        landing_field: this.form.landing_field
      }
      this.$axios.patch(`/forms/${this.parentForm.id}`, data)
        .then(resp => {
          this.$emit('update:parentForm', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickViewPage () {
      let domain = `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
      let url = domain +  this.form.slug + '?preview=true'
      window.open(url)
    },
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "page_content": "Page content",
    "main_content": "Main content",
    "tell_visitor_about": "Tell visitors what’s great about your product",
    "make_sure_click_publish": "Make sure to click Publish once you have finished editing your content. You may preview before publishing."
  },
  "id": {
    "page_content": "Halaman konten",
    "main_content": "Konten utama",
    "tell_visitor_about": "Beri tahu pengunjung keunggulan produk kamu",
    "make_sure_click_publish": "Pastikan klik 'Terbitkan' setelah kamu selesai mengedit konten kamu. kamu dapat melihat pratinjau sebelum menerbitkan."
  },
  "ms": {
  }
}
</i18n>